import {
	Text,
	View,
	StyleSheet,
	Pressable,
	FlatList,
	Image,
	StyleProp,
	ViewStyle,
} from "react-native";
import { discounts_4schools_image_path } from "../store/api";
const destaque1 = require("../../assets/images/destaque1.png");
const destaque2 = require("../../assets/images/destaque2.png");
const destaque3 = require("../../assets/images/destaque3.png");
const imageButton = require("../../assets/images/imageButton.png");

const HighlightedDiscountsRail = ({
	highlightDiscounts,
	navigation,
	style,
}) => {
	return (
		<View style={[styles.container, style]}>
			<FlatList
				horizontal
				data={highlightDiscounts}
				ListFooterComponent={() => <View></View>}
				renderItem={({ item, index }) => {
					return (
						<Pressable
							style={[
								styles.item,
								{
									marginLeft: index === 0 ? 24 : 0,
									backgroundColor: item.highlight.background_color,
									overflow: "hidden",
								},
							]}
							onPress={() =>
								navigation.navigate("Services", {
									screen: "SpecificDiscount",
									params: { info: item },
								})
							}
						>
							<Text style={styles.title}>{item.title}</Text>
							<Image
								source={{
									uri: discounts_4schools_image_path + item.highlight.image_id,
								}}
								style={[styles.image, { top: 60, left: 120 }]}
							/>
							<Pressable
								accessibilityRole="button"
								onPress={() =>
									navigation.navigate("Services", {
										screen: "SpecificDiscount",
										params: { info: item },
									})
								}
							>
								<Image source={imageButton} style={styles.imageButton} />
							</Pressable>
						</Pressable>
					);
				}}
			/>
		</View>
	);
};

export default HighlightedDiscountsRail;

const styles = StyleSheet.create({
	container: {
		flexDirection: "row",
		marginBottom: 20,
	},
	item: {
		width: 300,
		height: 272,
		borderRadius: 20,
		marginRight: 15,
		backgroundColor: "#888",
	},
	title: {
		fontFamily: "DmSans-bold",
		fontSize: 32,
		lineHeight: 40,
		position: "absolute",
		top: "12%",
		left: "10%",
		paddingRight: 30,
		zIndex: 2,
		color: "#fff",
	},
	image: {
		marginBottom: 36,
		marginLeft: 28,
		position: "absolute",
		width: 154,
		height: 215,
		top: 10,
		left: 110,
	},
	imageButton: {
		width: 140,
		height: 54,
		position: "absolute",
		top: 190,
		left: 20,
	},
});
